import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { CartProvider } from "./lib/cart";
import { I18nProvider } from "./lib/i18n";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import LandingPage from "./pages/LandingPage";
import DesignerPage from "./pages/DesignerPage";
import ShirtsPage from "./pages/ShirtsPage";
import StickersPage from "./pages/StickersPage";
import TegelDesignerPage from "./pages/TegelDesignerPage";
import TegeltjesPage from "./pages/TegeltjesPage";
import NotFoundPage from "./pages/NotFoundPage";
import MaakVoorMijPage from "./pages/MaakVoorMijPage";
import EtsenOpGlasPage from "./pages/EtsenOpGlasPage";
import AccessoiresPage from "./pages/AccessoiresPage";
import LogoUploadPage from "./pages/LogoUploadPage";
import UnsubscribePage from "./pages/UnsubscribePage";
import GiftCardPage from "./pages/GiftCardPage";
import TemplatesPage from "./pages/TemplatesPage";
// GalleryPage import removed (route removed Feb 2026 — user request)
import WishlistPage from "./pages/WishlistPage";
import SavedDesignsPage from "./pages/SavedDesignsPage";
import BulkOrderPage from "./pages/BulkOrderPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import OrderConfirmationPage from "./pages/OrderConfirmationPage";
import MyOrdersPage from "./pages/MyOrdersPage";
import ContactPage from "./pages/ContactPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import FaqPage from "./pages/FaqPage";
import CookieBanner from "./components/CookieBanner";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import AdminPage from "./pages/AdminPage";
import "./App.css";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <I18nProvider>
                    <AuthProvider>
                        <CartProvider>
                            <Navbar />
                            <main>
                                <Routes>
                                    <Route path="/" element={<LandingPage />} />
                                    <Route path="/designer" element={<Navigate to="/stickers" replace />} />
                                    <Route path="/shirts" element={<Navigate to="/stickers" replace />} />
                                    <Route path="/hoodies" element={<Navigate to="/stickers" replace />} />
                                    <Route path="/accessories" element={<Navigate to="/stickers" replace />} />
                                    <Route path="/stickers" element={<StickersPage />} />
                                    <Route path="/sticker-designer" element={<Navigate to="/stickers" replace />} />
                                    <Route path="/tegeltjes" element={<TegeltjesPage />} />
                                    <Route path="/tegel-designer" element={<TegelDesignerPage />} />
                                    <Route path="/cadeau-quiz" element={<Navigate to="/stickers" replace />} />
                                    <Route path="/maak-voor-mij" element={<MaakVoorMijPage />} />
                                    <Route path="/etsen-op-glas" element={<EtsenOpGlasPage />} />
                                    <Route path="/accessoires" element={<AccessoiresPage />} />
                                    <Route path="/upload-logo" element={<LogoUploadPage />} />
                                    <Route path="/unsubscribe" element={<UnsubscribePage />} />
                                    <Route path="/gift-card" element={<GiftCardPage />} />
                                    <Route path="/designs" element={<Navigate to="/stickers" replace />} />
                                    <Route path="/gallery" element={<Navigate to="/" replace />} />
                                    <Route path="/wishlist" element={<WishlistPage />} />
                                    <Route path="/saved-designs" element={<SavedDesignsPage />} />
                                    <Route path="/bulk-order" element={<BulkOrderPage />} />
                                    <Route path="/cart" element={<CartPage />} />
                                    <Route path="/checkout" element={<CheckoutPage />} />
                                    <Route path="/order/:id" element={<OrderConfirmationPage />} />
                                    <Route path="/my-orders" element={<MyOrdersPage />} />
                                    <Route path="/contact" element={<ContactPage />} />
                                    <Route path="/faq" element={<FaqPage />} />
                                    <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                                    <Route path="/reset-password" element={<ResetPasswordPage />} />
                                    <Route path="/terms" element={<TermsPage />} />
                                    <Route path="/privacy" element={<PrivacyPage />} />
                                    <Route path="/login" element={<LoginPage />} />
                                    <Route path="/register" element={<RegisterPage />} />
                                    <Route path="/admin" element={<AdminPage />} />
                                    <Route path="*" element={<NotFoundPage />} />
                                </Routes>
                            </main>
                            <Footer />
                            <WhatsAppButton />
                            <CookieBanner />
                        </CartProvider>
                    </AuthProvider>
                </I18nProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
